import {
  isMarketLeading,
  isRaisinUkExclusive,
  isShariaAccount,
  isStructuredDeposit,
  isTopOffer,
  isSustainableDeposit,
  isRateReducingSoon,
  isCustomLabel,
} from '../labelGenerators';

// product label functions in priority order
export const gbLabelGenerators = [
  isCustomLabel,
  isStructuredDeposit,
  isRateReducingSoon,
  isShariaAccount,
  isMarketLeading,
  isRaisinUkExclusive,
  isSustainableDeposit,
  isTopOffer,
];
